"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const mediaQueries = {
  "mobile": "420px",
  "tablet": "768px",
  "tabletWide": "1024px",
  "laptop": "1200px",
  "desktop": "1440px"
};
exports.default = mediaQueries;